import { useEffect, useState } from "react";
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";
import Logo from "../../assets/logo.png";
import styles from "./Navbar.module.css";
import clsx from "clsx"; 

const Navbar = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsVisible(false); 
      } else {
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  return (
    <nav className={clsx(styles.navbar, !isVisible && styles.navbarHidden)}>
      <div className={styles.content}>
        <img src={Logo} alt="Company Logo" className={styles.logo} />
        <LanguageSwitcher />
      </div>
    </nav>
  );
};

export default Navbar;
